import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/networkError.css";

const NetworkErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="network-error-container">
      <div className="network-error-content">
        <div className="network-animation">
          <svg className="wifi-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12.55a11 11 0 0 1 14.08 0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M1.42 9a16 16 0 0 1 21.16 0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M9 20h6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <circle cx="12" cy="20" r="1" fill="currentColor"></circle>
          </svg>
          <div className="pulse-ring"></div>
        </div>
        <h1>Network Error</h1>
        <p>We couldn't connect to the server. Please check your internet connection and try again.</p>
        <button onClick={() => {
            navigate("/search"); 
            window.location.reload();}} className="retry-button">
          Go back & Retry
        </button>
      </div>
    </div>
  );
};

export default NetworkErrorPage;
